"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var ImageContent = /** @class */ (function (_super) {
    __extends(ImageContent, _super);
    function ImageContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageContent.prototype.render = function () {
        var _a;
        var section = this.props.section;
        var _b = section.settings, settings = _b === void 0 ? {} : _b, blocks = section.blocks;
        var 
        /* @ts-ignore */
        reverse = settings.reverse, alignment = settings.alignment, foreground = settings.foreground, background = settings.background, fullwidth = settings.fullwidth, verticalspacing = settings.verticalspacing, 
        /* @ts-ignore */
        linkurl = settings.linkurl, image = settings.image, imagemobile = settings.imagemobile, label = settings.label, title = settings.title, content = settings.content, linktext = settings.linktext, linkurltarget = settings.linkurltarget;
        var linkTarget = linkurltarget ? "_blank" : "_self";
        var isReversed = ((_a = reverse) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "right";
        var textAlignment = alignment ? alignment.toLowerCase() : "center";
        var textForeground = foreground ? foreground.toLowerCase() : "arctic";
        var hasSettingsAndBlocks = settings && blocks;
        if (!hasSettingsAndBlocks) {
            return (React.createElement(Snippets.Container, { width: "xl mlg:px-11", collapsedSmall: true, className: "dynamic-image-text mb-3-2", tag: "section" },
                React.createElement("div", { className: "h-28 content-placeholder" })));
        }
        return (React.createElement(Snippets.Container, { width: fullwidth ? "full" : "xl mlg:px-11", collapsedSmall: true, className: "dynamic-image-text" + (verticalspacing ? " py-3-2 md:py-6-4" : ""), tag: "section" },
            React.createElement("a", { className: "flex flex-row flex-wrap md:flex-no-wrap " + background + "\n          " + (background === "dark" || background === "navy" ? "bg-gradient" : "bg-" + background) + " text-" + textForeground + " text-" + textAlignment + (isReversed ? " md:flex-row-reverse" : ""), href: linkurl || "", target: linkTarget },
                React.createElement("div", { className: "w-full relative md:w-1/2" },
                    React.createElement("div", { className: "parallelogram h-full w-full overflow-hidden hidden md:block absolute " + (isReversed ? "reverse" : "") },
                        React.createElement(Snippets.Image, { bg: background, bgNatural: false, ratio: "3:2", src: image, className: "h-full max-w-full", alt: "" })),
                    React.createElement("div", { className: "block md:hidden " },
                        React.createElement(Snippets.Image, { bgNatural: true, ratio: "3:2", src: imagemobile || image, className: "max-w-full", width: window.innerWidth, alt: "" }))),
                React.createElement("div", { className: "w-full md:min-h-0 flex flex-col justify-between md:flex-1 py-4 px-5-6 md:py-5-6 md:px-8 lg:px-10 max-w-xs mx-auto" },
                    label && React.createElement("p", { className: "text-xs leading-none uppercase tracking-wider font-medium mb-2-4" }, label),
                    title || content ? (React.createElement("div", null,
                        title ? (React.createElement(Snippets.Heading, { size: "h2", tag: "h3", title: title, className: "text-36 tracking-none leading-tightest font-extrabold mb-0-4" }, title)) : null,
                        content ? (React.createElement(Snippets.RichText, { className: "" + (title ? "mt-1-6" : "") + (textForeground == "midnight" ? " text-charcoal" : ""), size: "base" }, content)) : null)) : (React.createElement("br", null)),
                    linkurl ? (React.createElement(Snippets.Button
                    // href={settings.linkurl}
                    , { 
                        // href={settings.linkurl}
                        style: "chevron", reverse: true, className: "ml-0 block w-full pt-0-4 mt-2-4 h-4-8 px-2-4 max-w-32 uppercase text-md tracking-none font-extrabold" }, linktext || "Shop Collection")) : (React.createElement("br", null))))));
    };
    ImageContent.sectionId = "imgtxt";
    return ImageContent;
}(React.PureComponent));
exports.ImageContent = ImageContent;
